import React, { ReactElement, ReactNode } from 'react';
import { Form } from 'react-bootstrap';

type RolesContainerProps = {
    children: ReactNode;
};

export default function RolesContainer(props: RolesContainerProps): ReactElement {
    return (
        <Form.Group
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
            }}
        >
            {props.children}
        </Form.Group>
    );
}
